<div class="ui-g">
  <div class="ui-g-12 text-right">
    <button
      pButton
      type="button"
      class="k-generic-btn"
      icon="fa fa-plus"
      iconPos="left"
      label="{{ 'report.createNewReport' | translate }}"
      (click)="openModal()">
    </button>
  </div>
  <div class="ui-g-12">
    <app-campaign-3-kontable *ngIf="translationsReady"
      #table
      title="{{ 'report.title' | translate }}"
      [columns]="[
        'id',
        'code',
        'description',
        'query_count',
        {field: 'report_state', title: 'report.reportState', bodyTemplate: reportStateTemplate, filterType: selectFilter, filterOptions: {values: reportStates}},
        {field: 'ts_ins', title: 'promo.requestedDate', bodyTemplate: dateTimeTemplate, filterType: dateFilter},
        {field: 'ts_upd', title: 'promo.endExecutionDate', bodyTemplate: dateTimeTemplate, filterType: dateFilter}
      ]"
      [titles]="[
        'common.id',
        'common.code',
        'common.description',
        'customerSetBuilder.recordCount'
      ]"
      [paginationType]="paginationType"
      [showInfoButton]="false"
      [showRecoverButton]="false"
      [showGlobalFilter]="false"
      [showEditButton]="false"
      [showDeleteButton]="false"
      (onDetails)="showProcessingDetail($event.error)"
      
      [service]="reportService"
      [additionalRowCommands]="customButton">
      <ng-template #customButton data-testid="customButton" let-row>
        <p-button
          icon="fa fas fa-download"
          styleClass="ui-button-info"
          *ngIf="row.report_state === 'P'"
          (onClick)="downloadPromoReport(row.id, row.code)"
          pTooltip="{{ 'report.downloadReport' | translate }}">
        </p-button>
      </ng-template>
      <ng-template #reportStateTemplate data-testid="reportStateTemplate" let-row>
        <span *ngIf="row.report_state === '0'">
          {{'report.generated' | translate}}
        </span>
        <span *ngIf="row.report_state === 'E'">
          {{'report.onError' | translate}}
        </span>
        <span *ngIf="row.report_state === 'P'">
          {{'report.downloadReady' | translate}}
        </span>
        <span *ngIf="row.report_state === 'A'">
          {{'report.onExecution' | translate}}
        </span>
        <!-- Localizzare -->
        <span *ngIf="row.report_state === 'C'">
          {{'report.creation' | translate}}
        </span>
        <span *ngIf="row.report_state === 'Z'">
          {{'report.withoutData' | translate}}
        </span>


        
    </ng-template>
    <ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row let-value="value">
      {{value | date: 'dd/MM/yyyy hh:mm'}}
    </ng-template>
    </app-campaign-3-kontable>
  </div>
</div>

<p-dialog
  *ngIf="showModal"
  header="{{ 'report.createNewReport' | translate }}"
  [(visible)]="showModal"
  [modal]="true"
  [width]="700"
  [draggable]="false"
  [resizable]="false">
  <app-promo-report-form (onCloseModal)="closeModal()" (onSaveReport)="onSaveReport()"></app-promo-report-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/promotion/report/promo-report-list/promo-report-list.component.html